/**
 * Imports the Freighthub API.
 */
import { api } from '../api.js';

export default {
    /**
     * GET api.freighthub.nz/carrier/gps/schedule-monitor/truck-running-settings
     */
    get: function(){
        return api.get( '/carrier/gps/schedule-monitor/truck-running-settings');
    },

    /**
     * POST api.freighthub.nz/carrier/gps/schedule-monitor/truck-running-settings
     */
    post: function({ branch_name, name, email, mobile, notifiable, notifiable_via, time_threshold, subscribe_all, destination_place_ids }){
        return api.post('/carrier/gps/schedule-monitor/truck-running-settings', {
            branch_name,
            name,
            email,
            mobile,
            notifiable,
            notifiable_via,
            time_threshold,
            subscribe_all,
            destination_place_ids,
        })
    },

    /**
     * PUT api.freighthub.nz/carrier/gps/schedule-monitor/truck-running-settings
     */
    put: function({ id, branch_name, name, email, mobile, notifiable, notifiable_via, time_threshold, subscribe_all, destination_place_ids }){
        return api.put('/carrier/gps/schedule-monitor/truck-running-settings/' + id, {
            branch_name,
            name,
            email,
            mobile,
            notifiable,
            notifiable_via,
            time_threshold,
            subscribe_all,
            destination_place_ids,
        })
    },
}